import { Component, OnInit, ViewChild, Inject, ViewEncapsulation, Input, ViewContainerRef } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PartyContactMechanisms, SCHOOL_STATUS } from 'src/app/model/school.model';
import { PARTYROLE } from 'src/app/model/region.model';
import { MatDialog } from '@angular/material/dialog';
import { EditSchoolDistrictsComponent } from 'src/app/component/system/school-districts/edit-school-districts/edit-school-districts.component';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Region } from '../../../../model/region.model';
import { MsgModel } from '../../../common-components/msg/model/msg.model';
import { UserProfileService } from '../../../user-profile/service/user-profile.service';
import { User } from '../../../auth/model/user.model';
import { OrganizationService } from 'src/app/component/common-components/organizations/service/organization.service';
import { ORGANIZATION } from 'src/app/model/school.model';
import { Observable } from 'rxjs/internal/Observable';
import { Subject } from 'rxjs';
// for backup/restore setup
import { ApiSchoolDistrictsService } from 'src/app/service/api-school-districts.service';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';

@Component({
    selector: 'app-school-district-view',
    templateUrl: './school-district-view.component.html',
    styleUrls: ['./school-district-view.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SchoolDistrictViewComponent implements OnInit {
    @ViewChild(MatAccordion) accordion!: MatAccordion;

    @Input() inOrgId!: number;

    schoolDistrict: SchoolDistrict;
    closedDate: string = '';
    county: string = '';
    district: string = '';
    region: string = '';
    regionCode: string = '';
    regionName: string = ''; // fully qualified name
    schoolDistrictCode: string = '';
    schoolDistrictNCES: string = '';

    user: User = {};
    partyRoles: PARTYROLE[] = [];
    regions: Region[] = [];
    userIdChanged: boolean = false;
    partyContactMechanisms: PartyContactMechanisms[] = [];
    deletePartyContactMechanisms: PartyContactMechanisms[] = [];
    isEditingPartyContactMechanisms: Event; //boolean = false;

    isLoading: boolean = false;
    msg: MsgModel = {};
    userIdChangedMsg: MsgModel = {};
    promises: Array<any> = [];

    districtInfoForm!: UntypedFormGroup;
    schoolDistrictName: string = '';

    organizationService: any;
    partyId: any = [{}];
    organizationId!: number;
    myOrganization!: ORGANIZATION;
    partyIdNum!: number;

    constructor(
        public dialogRef: MatDialogRef<SchoolDistrictViewComponent>,
        @Inject(MAT_DIALOG_DATA) public editData: any,
        organizationService: OrganizationService,
        private dialog: MatDialog,
        private fb: UntypedFormBuilder,
        private userProfileService: UserProfileService,
        private viewContainerRef: ViewContainerRef,
        private apiSchoolDistrictsService: ApiSchoolDistrictsService
    ) {
        this.organizationService = organizationService;

        this.districtInfoForm = fb.group({
            schoolDistrictName: ['', [Validators.required]],
            schoolDistrictCode: ['', null],
            schoolDistrictNCES: ['', [Validators.required]]
        });
        this.isLoading = true;
    }

    ngOnInit(): void {
        console.log('getting userprofile');
        //this.getUserProfile();

        Promise.all(this.promises).then((res) => {
            // console.log("reading this:" + Object.entries(res))
            // console.log("here's the data coming in:" + this.editData)
            // console.log(Object.keys(this.editData));
            // console.log(Object.values(this.editData));
            // this.getPartyRoles();
            // console.log("got party roles")
            // this.getRegionsByPartyId();
            // console.log("got regions by party id")
        });

        this.fnInit();
    }

    fnInit() {
        console.log('calling fnInit');
        console.log('edit data object');
        console.log(this.editData);

        console.log('passed in id is:');
        console.log(this.editData['ID']);
        // set school object
        this.apiSchoolDistrictsService.show(this.editData['ID']).subscribe((res) => {
            this.schoolDistrict = res.schoolDistrict;
            //this.schoolDistrict = this.editData; //res.schoolDistrict;
            //this.schoolDistrictName = this.editData['DISTRICTS'];
            this.schoolDistrictName = this.schoolDistrict.DISTRICTS || this.editData['DISTRICTS'];
            // set school data
            const regionShell = this.schoolDistrict.REGIONS; // this.editData['REGIONS'];
            this.regionName = regionShell.NAME || ''; //['NAME']; //regionShell['NAME'] || '';
            this.region = regionShell.NAME || ''; //this.schoolDistrict.REGIONS;// this.regionName;
            this.regionCode = regionShell.CODE!; //["CODE"];
            this.schoolDistrictCode = this.schoolDistrict.CODE.toString(); // this.editData['CODE']; // schoolDistrict.CODE.toString() || ''; //districtShell['CODE'].toString();
            this.schoolDistrictNCES = this.schoolDistrict.NCESDist.toString(); // this.editData['NCESDist'];// .toString() || '';

            this.county = this.schoolDistrict.COUNTy.COUNTY_CODE + ' - ' + this.schoolDistrict.COUNTy.COUNTY_NAME; // editData['COUNTy'] this.editData['COUNTy']  translateCounty[2] + " (" + translateCounty[3] + ")"; // translateCounty + " (" + this.schoolDistrict.COUNTy.ID + ")"; // translateCounty[2] + " (" + translateCounty[3] + ")";
            /*  console.log("incomingData:" + this.region + "," + this.county + "," + this.district
       + "," + this.CDSCode + "," + this.NCES      
     ); */

            this.isLoading = false;

            // load party data
            if (this.schoolDistrict.ORGANIZATIONS_ID) {
                this.organizationId = this.schoolDistrict.ORGANIZATIONS_ID; //this.editData['ORGANIZATIONS_ID'];

                this.organizationService.show(this.organizationId).subscribe({
                    next: (res: any) => {
                        this.myOrganization = res.organization;
                        //console.log("organization is: " + Object.entries(this.myOrganization));
                        //console.log("party ids are: " + this.myOrganization.PARTIES_ID)
                        this.partyId = this.myOrganization.PARTIES_ID;
                        this.partyIdNum = parseInt(this.partyId);

                        //console.log("inbound organization id1 is: " + this.organizationId);
                        //console.log("my organization: " + this.myOrganization.PARTIES_ID);
                    },
                    error: (err: any) => {
                        alert('Error while fetching the records');
                        console.log('error while getting organization data');
                    }
                });
            }
        });
    }

    editRecord() {
        const dialogRef = this.dialog.open(EditSchoolDistrictsComponent, {
            width: '90%',
            height: '90%',
            data: this.editData,
            viewContainerRef: this.viewContainerRef
        });
        dialogRef.afterClosed().subscribe((result) => {
            console.log('passing result');
            console.log(result);
            this.fnInit();
        });
    }
    closeRecord() {
        this.dialogRef.close(this.schoolDistrict);
    }

    getUserProfile() {
        let deferred = new Promise((resolve, reject) => {
            this.userProfileService.getMyProfile().subscribe((res) => {
                if (res?.user) {
                    this.user = res.user;
                    this.districtInfoForm.patchValue({
                        firstName: this.user.PERSON?.FIRST_NAME,
                        middleInitial: this.user.PERSON?.MIDDLE_INITIAL,
                        lastName: this.user.PERSON?.LAST_NAME,
                        suffix: this.user.PERSON?.SUFFIX,
                        workTitle: this.user.WORK_TITLE,
                        workEmail: this.user.EMAIL_ADDRESS,
                        username: this.user.USER_ID
                    });
                    resolve(res);
                } else if (res?.msg) {
                    reject(res);
                } else {
                    reject('err');
                }
            });
        });
        this.promises.push(deferred);
    }
}
